import React, { Suspense, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { wrapPromise } from "go-core";
import Header from "go-app/components/Header";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { useWindowSize } from "go-core/components/useWindowSize";
import { selectOrganization } from "go-security/services/organizations/selectors";
import Segment, { HyperLinksConfigState } from "go-segment/components";
import { SegmentContext } from "go-segment/context";

const listName = "SEGMENT";
const resourceType = "SEGMENT";

const OrganizationSettingsSegmentsPage = () => {
	const { t } = useTranslation();
	const organization = useSelector(selectOrganization);
	const [resource, setResource] = useState<Record<string, any>>();
	const { isMobile } = useWindowSize();
	const resourceFilterTypes = {};
	const hyperLinksConfig: HyperLinksConfigState[] = [
		{
			list_name: "CONTACT_GROUP",
			url: `/${organization.id}/settings/contact_groups`,
		},
		{
			list_name: "ORGANIZATION_USERS",
			url: `/${organization.id}/settings/users`,
		},
	];
	const segmentContextValue = React.useContext(SegmentContext);
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		handleChangeTabTitle(t("lib:go_segment.list.header.title"));
		setResource(wrapPromise(segmentContextValue.get(listName, resourceType)));
	}, []);

	return (
		<div className={"content"}>
			{!isMobile && <Header title={t("lib:go_segment.list.header.title")} />}
			<Suspense fallback={<LoadingContainer />}>
				<Segment.SegmentList
					segmentListService={segmentContextValue}
					organizationName={organization.name ? organization.name : ""}
					resourceFilterTypes={resourceFilterTypes}
					resource={resource}
					listName={listName}
					resourceType={resourceType}
					hyperLinksConfig={hyperLinksConfig}
				/>
			</Suspense>
		</div>
	);
};
export default OrganizationSettingsSegmentsPage;
